import React from 'react';

interface CourseDetailBannerProps {
  courseTitle: string;
  progressPercent: number;
  messageTitle?: string;
  messageDescription?: string;
  loading?: boolean;
}

const CourseDetailBanner: React.FC<CourseDetailBannerProps> = ({
  courseTitle,
  progressPercent,
  messageTitle,
  messageDescription,
  loading = false,
}) => {
  // Use inline CSS variable to drive the progress ring's conic gradient
  const ringStyle = { ['--progress' as any]: progressPercent } as React.CSSProperties;

  return (
    <div className="course-detail-banner">
      <div className="course-detail-blue-header">
        <div className="course-detail-blue-content">
          {loading ? (
            <>
              <div className="skeleton skeleton-text" style={{ width: 220, height: 16, marginBottom: 8 }} />
              <div className="skeleton skeleton-text" style={{ width: 280, height: 24 }} />
            </>
          ) : (
            <>
              <div className="course-detail-blue-subtitle">AI MASTERY • {courseTitle}: LEVEL 1</div>
              <div className="course-detail-blue-title">Introduction to {courseTitle}</div>
            </>
          )}
        </div>
        {loading ? (
          <div className="skeleton skeleton-text" style={{ width: 24, height: 24, borderRadius: 6 }} />
        ) : (
          <div className="course-detail-menu-icon">☰</div>
        )}
      </div>
      <div className="course-detail-white-card">
        <div className="course-detail-card-content">
          <div className="course-detail-card-text">
            {loading ? (
              <>
                <div className="skeleton skeleton-text" style={{ width: 240, height: 20, marginBottom: 6 }} />
                <div className="skeleton skeleton-text" style={{ width: 300, height: 14 }} />
              </>
            ) : (
              <>
                <div className="course-detail-card-title">{messageTitle}</div>
                <div className="course-detail-card-subtitle">{messageDescription}</div>
              </>
            )}
          </div>
          <div className="course-detail-card-progress">
            {loading ? (
              <div className="skeleton skeleton-circle" style={{ width: 60, height: 60 }} />
            ) : (
              <div className="course-detail-progress-ring" style={ringStyle}>
                <span>{progressPercent}%</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailBanner;
